import Request from './request'

const SimcardProfileGroup = {
  getSimcardProfileGroupList(params, callback) {
    Request.get('simcard-profile-groups', params).then(callback).catch(this.bad_answer)
  },
  getSimcardProfileGroupInfo(id, params, callback) {
    Request.get('simcard-profile-groups/' + id, params).then(callback).catch(this.bad_answer)
  },
}
export default SimcardProfileGroup
